var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.quoteData && _vm.quoteData.length
    ? _c(
        "div",
        {
          staticClass: "cardRecentIndicators",
          attrs: { "data-epica-module-name": "Indicadores Recientes" },
        },
        [
          _c("h3", { staticClass: "nameIndicator" }, [_vm._v("RECIENTES")]),
          _vm._v(" "),
          _vm._l(_vm.quoteData, function (quote) {
            return _c("a", { key: quote.id, attrs: { href: quote.url } }, [
              _c(
                "div",
                { staticClass: "d-flex recentIndicators align-items-center" },
                [
                  _c("div", { staticClass: "col-5 p-0" }, [
                    _c("span", {
                      staticClass: "nameIndicator",
                      domProps: { innerHTML: _vm._s(quote.name) },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-7 p-0 text-right" }, [
                    _c("span", {
                      staticClass: "varAbs",
                      domProps: { innerHTML: _vm._s(quote.value) },
                    }),
                    _vm._v(" "),
                    _c("i", {
                      class:
                        "icon-" + quote.upDownClass + " " + quote.upDownClass,
                    }),
                  ]),
                ]
              ),
            ])
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }